import { find, get, isEmpty, map } from 'lodash-es';

import uuidv4 from 'uuid/v4';
import { checkIsEmpty } from '../../utils';

/**
 * get question
 * @param generalData
 */
const getQuestionGroup = generalData => ({
  code: get(generalData, 'code'),
  sequence: get(generalData, 'sequence'),
});

const handleQuestionGroup = group => {
  let questions = [];

  // from web service
  if (!isEmpty(get(group, 'extra_data'))) {
    questions = map(get(group, 'extra_data'), generalData => getQuestionGroup(generalData));
  }

  // from store
  if (!isEmpty(get(group, 'questions'))) {
    questions = [...questions, ...map(get(group, 'questions'), question => getQuestionGroup(question))];
  }

  return questions;
};

/**
 * get group
 * @param group
 */
const getGroup = group => ({
  id: !checkIsEmpty(get(group, 'id')) ? get(group, 'id') : uuidv4(),
  title: get(group, 'title'),
  description: get(group, 'description'),
  tooltip: get(group, 'tooltip'),
  sequence: get(group, 'sequence'),
  questions: handleQuestionGroup(group),
  // todo verify reel case
  groups: !isEmpty(get(group, 'groups')) ? map(get(group, 'groups'), groupItem => getGroup(groupItem)) : undefined,
});

/**
 * get question
 * @param {*} question
 */
const getQuestion = (question, answerValue) => {
  try {
    let validation = [];

    if (!isEmpty(get(question, 'validation'))) {
      validation = get(question, 'validation');
    }

    if (question.required) {
      validation.push({ required: true, message: ' ' /* 'champ obligatoire' */ }); // HACK demo to not display error message
    }

    const result = {
      ...question,
      value: answerValue,
      validation,
    };
    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getPart ${e.stack}`);
  }
  return undefined;
};

/**
 * get answer value
 * @param {} answersQuestion
 * @param {} questionItem
 */
const getAnswerValue = (answersQuestion, questionItem) => {
  if (get(questionItem, 'path.path')) {
    if (get(questionItem, 'path.root') === 'loans') {
      return get(answersQuestion, `${get(questionItem, 'path.root')}[0].${get(questionItem, 'path.path')}`);
    }

    return get(answersQuestion, `${get(questionItem, 'path.root')}.${get(questionItem, 'path.path')}`);
  }

  return get(answersQuestion, questionItem.code);
};

/**
 * get part
 * @param part
 */
const getPart = (part, answersQuestion) => {
  try {
    const questions = map(get(part, 'questions'), questionItem => {
      const question = getQuestion(questionItem, getAnswerValue(answersQuestion, questionItem));
      return question;
    });
    const groups = !isEmpty(get(part, 'groups')) ? map(get(part, 'groups'), group => getGroup(group)) : undefined;
    const result = {
      ...part,
      questions,
      groups,
    };
    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getPart ${e.stack}`);
  }
  return undefined;
};

/**
 *
 * @param {*} answersParts
 * @param {*} part
 */
const getAnswersQuestions = (part, answersParts) => {
  try {
    const answersPart = find(answersParts, { id: get(part, 'id') });
    const answersQuestions = get(answersPart, 'answers');
    return answersQuestions;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getAnswersQuestions ${e.stack}`);
  }
  return undefined;
};

/**
 * get block loan
 * @param block
 */
const getBlock = (block, salesRoute, answersParts = undefined) => {
  try {
    const parts = map(get(block, 'parts'), partItem => {
      const answersQuestions = answersParts ? getAnswersQuestions(partItem, answersParts) : undefined;
      const part = getPart(partItem, answersQuestions);
      return part;
    });
    const result = {
      id: get(salesRoute, '_id', '123'),
      code: get(block, 'code'),
      icon: get(block, 'icon'),
      title: get(block, 'title'),
      description: get(block, 'description'),
      sequence: get(block, 'sequence'),
      displayTitle: get(block, 'displayTitle', true),
      parts,
    };
    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getBlock ${e.stack}`);
  }
  return undefined;
};

/**
 *  get answers
 * @param {*} salesRoute
 */
const getAnswers = salesRoute => {
  try {
    const { ref, ...answers } = get(salesRoute, 'quotations[0]', {});
    const parts = [{ id: 1, answers: { quotations: answers, loans: get(salesRoute, 'loans', []) } }];

    // check answers parts is empty
    if (isEmpty(parts)) {
      return undefined;
    }

    const answersFinal = { id: ref, parts };
    return answersFinal;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return undefined;
};

/**
 *
 * @param {*} param0
 */
const generalDataBlockTransform = ({ salesRoute }) => {
  try {
    const block = get(salesRoute, 'questionnaires[0].description.generalData_block');

    const answers = getAnswers(salesRoute);
    const checkLoansHasAnswers = !isEmpty(get(answers, 'parts'));

    // const isReady = questionnaireBlockIsReady({ questionnaire });

    // if (!isReady) {
    //   // eslint-disable-next-line no-console
    //   return {};
    // }

    // build block
    return getBlock(block, salesRoute, checkLoansHasAnswers ? get(answers, 'parts') : undefined);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`questionnaireBlockTransform: ${e.stack}`);
  }

  return {};
};

export default generalDataBlockTransform;
